import { l } from '../lib/imports'
import { log } from './log-sidecar'

let map: { [key: string]: Array<(data: any) => void> } = {}

const logNamespace = 'pubsub'
export function emit(actionName: string, data?: any) {
  log.x(logNamespace, 'emit', actionName)
  l.forEach(map[actionName], (c) => {
    log.x(logNamespace, '> on', actionName)
    c(data)
  })
}

export function on(actionName: string, cb: (data?: any) => any) {
  log.x(logNamespace, 'sub', 'on', actionName)
  if (!map[actionName]) {
    map[actionName] = []
  }

  map[actionName].push(cb)
}
